<template>
  <div class="product-page">
    <!-- 页面标题和描述 -->
    <div 
      class="page-header"
      :style="{
        backgroundImage: pageData.cover ? `url(${pageData.cover})` : '',
      }"
    >
      <div class="container">
        <h1>{{ pageData.name || '信创服务' }}</h1>
        <p class="description">{{ pageData.desc }}</p>
      </div>
    </div>

    <!-- 服务内容 -->
    <section class="section services-section">
      <div class="container">
        <h2 class="section-title">服务内容</h2>
        <div class="services-grid">
          <div 
            v-for="service in productData.services" 
            :key="service.title"
            class="card service-card"
          >
            <div class="icon-wrapper">
              <el-icon>
                <component :is="service.icon" />
              </el-icon>
            </div>
            <h3>{{ service.title }}</h3>
            <p>{{ service.description }}</p>
            <ul class="feature-list">
              <li v-for="feature in service.features" :key="feature">
                {{ feature }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务流程 -->
    <section class="section process-section">
      <div class="container">
        <h2 class="section-title">服务流程</h2>
        <div class="process-steps">
          <div 
            v-for="(step, index) in productData.process" 
            :key="step.title"
            class="step-item"
          >
            <div class="step-number">{{ index + 1 }}</div>
            <h3>{{ step.title }}</h3>
            <p>{{ step.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务优势 -->
    <section class="section advantages-section">
      <div class="container">
        <h2 class="section-title">服务优势</h2>
        <div class="advantages-grid">
          <div 
            v-for="advantage in productData.advantages" 
            :key="advantage.title"
            class="card advantage-card"
          >
            <div class="icon-wrapper">
              <el-icon>
                <component :is="advantage.icon" />
              </el-icon>
            </div>
            <h3>{{ advantage.title }}</h3>
            <p>{{ advantage.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 合作伙伴 -->
    <!-- <section class="section partners-section">
      <div class="container">
        <h2 class="section-title">合作伙伴</h2>
        <div class="partners-list">
          <div 
            v-for="partner in productData.partners" 
            :key="partner.name"
            class="partner-item"
          >
            <img :src="partner.logo" :alt="partner.name">
            <span>{{ partner.name }}</span>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { columnGet2 } from "@/api/court";
import { 
  Monitor,
  Setting,
  Tools,
  Lock,
  Platform,
  Service,
  DataLine,
  Management,
  CircleCheck,
  Connection
} from '@element-plus/icons-vue'

const pageData = ref({})

// 获取页面数据
const getPageData = async () => {
  try {
    const response = await columnGet2({
      page: 1,
      limit: 10000,
      is_enable: true,
      parent: 9,
    });
    if (response.data.code === 2000) {
      // 根据当前页面名称匹配对应的数据
      const data = response.data.data.data.find(item => {
        // 根据路径匹配对应的数据
        return item.name.includes('信创服务') || item.name.toLowerCase().includes('innovation')
      })
      if (data) {
        pageData.value = data
      }
    }
  } catch (error) {
    console.error('获取页面数据失败:', error)
  }
}

onMounted(() => {
  getPageData()
})

const productData = {
  title: '信创服务',
  description: '系统集成、迁移与适配、信创运维。',
  services: [
    {
      icon: Monitor,
      title: '系统集成服务',
      description: '提供全面的信创系统集成解决方案，包括软硬件系统集成、应用系统适配、数据迁移等服务。',
      features: [
        '软硬件系统集成',
        '应用系统适配',
        '数据迁移服务',
        '集成测试验证'
      ]
    },
    {
      icon: Setting,
      title: '迁移适配服务',
      description: '专业的系统迁移和适配服务，确保系统平稳迁移和稳定运行。',
      features: [
        '系统迁移评估',
        '应用改造适配',
        '数据迁移服务',
        '性能优化服务'
      ]
    },
    {
      icon: Tools,
      title: '信创运维服务',
      description: '全方位的信创环境运维保障，提供持续的技术支持和运维服务。',
      features: [
        '系统运维服务',
        '性能监控优化',
        '安全运维服务',
        '技术支持服务'
      ]
    }
  ],
  process: [
    {
      title: '需求分析',
      description: '深入了解客户需求，评估现有系统情况'
    },
    {
      title: '方案设计',
      description: '制定详细的信创改造实施方案'
    },
    {
      title: '实施部署',
      description: '按计划实施系统迁移和适配工作'
    },
    {
      title: '测试验证',
      description: '全面测试验证系统功能和性能'
    },
    {
      title: '运维保障',
      description: '提供持续的运维服务和技术支持'
    }
  ],
  advantages: [
    {
      icon: Tools,
      title: '专业团队',
      description: '经验丰富的技术团队'
    },
    {
      icon: Connection,
      title: '完整方案',
      description: '端到端的解决方案'
    },
    {
      icon: Service,
      title: '快速响应',
      description: '高效的服务响应'
    },
    {
      icon: CircleCheck,
      title: '品质保障',
      description: '严格的质量管控'
    }
  ],
  partners: [
    { name: '合作伙伴A', logo: '/path/to/logo1.png' },
    { name: '合作伙伴B', logo: '/path/to/logo2.png' },
    { name: '合作伙伴C', logo: '/path/to/logo3.png' },
    { name: '合作伙伴D', logo: '/path/to/logo4.png' }
  ]
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/products.scss';

.page-header {
  background-size: cover;
  background-position: center;
  color: #fff;
  padding: 60px 0 60px;  /* 修改padding，与System.vue保持一致 */
  text-align: center;
  position: relative;
  overflow: hidden;
  margin-bottom: 60px;
  display: flex;  /* 添加flex布局 */
  align-items: center;  /* 垂直居中 */

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0.5;
    z-index: 1;
  }

  .container {
    position: relative;
    z-index: 2;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  h1 {
    font-size: 36px;
    margin-bottom: 10px;
    position: relative;
    display: inline-block;
    opacity: 0;
    transform: translateY(20px);
    animation: fadeInUp 0.8s ease forwards;
  }

  .description {
    font-size: 18px;
    opacity: 0;
    transform: translateY(20px);
    animation: fadeInUp 0.8s ease forwards 0.2s;
    margin: 20px auto 0;
    max-width: 800px;
    line-height: 1.8;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media screen and (max-width: 768px) {
  .page-header {
    background-size: cover;
    padding: 60px 0 40px;  /* 移动端padding调整 */
   /* 移动端高度调整 */
  }
}

// 页面特定样式调整
.services-section {
  .services-grid {
    .service-card {
      display: flex;
      flex-direction: column;

      .feature-list {
        margin-top: auto;
        padding-top: 20px;
      }
    }
  }
}

.advantages-section {
  .advantages-grid {
    .advantage-card {
      text-align: center;

      .icon-wrapper {
        margin: 0 auto 20px;
      }
    }
  }
}

.partners-section {
  .partners-list {
    .partner-item {
      img {
        max-height: 60px;
        width: auto;
      }
    }
  }
}
</style> 